export const SecondsInMinute = 60;
export const SecondsInHour = SecondsInMinute * 60;
export const SecondsInDay = SecondsInHour * 24;
export const SecondsInWeek = SecondsInDay * 7;
export const SecondsInLongestMonth = SecondsInDay * 31;
export const SecondsInYear = SecondsInDay * 365;
export const TimeFormat12Hour = 'hh:mm a';
export const TimeFormat24Hour = 'HH:mm';
